<div aria-labelledby="number-traits-tab" class="tab-pane active container-fluid" role="tabpanel">
	<div class="row">
		<div class="col-12">
			<div class="d-flex justify-content-between align-items-start">
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.description"></span>
			</div>
		</div>
	</div>
	<div class="table-responsive">
		<table class="table table-striped table-bordered table-curved">
			<thead>
            <tr>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.trait"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.number.of.locations"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.number.of.lines"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.number.of.observations"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.min"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.median"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.max"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.condition"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.limits"></span>
			</th>
			<th [ngStyle]="{ 'width': '120px' }">
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.table.header.weight"></span>
			</th>
            </tr>
			<tbody *ngIf="traitFilterContext.hasNumericTraits() else nodata">
			<tr *ngFor="let numberTrait of traitFilterContext.numericTraits">
				<td>
					<a (click)="$event.stopPropagation()" [queryParams]="{ name: numberTrait.name, type: 'Numeric' }" [routerLink]="['/', { outlets: { popup: 'trait-observation-dialog/' + numberTrait.id } }]" queryParamsHandling="merge">
						<truncate-span [textInput]="numberTrait.name"></truncate-span>
					</a>
				</td>
				<td>{{ numberTrait.locationCount }}</td>
				<td>{{ numberTrait.germplasmCount }}</td>
				<td>{{ numberTrait.observationCount }}</td>
				<td>{{ showRoundOff(numberTrait.minValue) }}</td>
				<td>{{ showRoundOff(numberTrait.medianValue) }}</td>
				<td>{{ showRoundOff(numberTrait.maxValue) }}</td>
				<td [ngStyle]="{ 'min-width': '120px' }">
					<select (ngModelChange)="selectedCondition(numberTrait)" [(ngModel)]="numberTrait.condition" class="form-select">
						<ng-container>
							<option *ngFor="let opt of conditionOptions" [value]="opt.value">
								{{ opt.label | translate }}
							</option>
						</ng-container>
					</select>
				</td>
				<td>
					<input
						[(ngModel)]="numberTrait.limits"
						[class.is-invalid]="!traitFilterContext.isNumericLimitValid(numberTrait)"
						[disabled]="isLimitsDisabled(numberTrait)"
						class="form-control"
						type="text"
					/>
					<div *ngIf="!traitFilterContext.isNumericLimitValid(numberTrait)" class="invalid-feedback d-block">
						{{ showMessageError(numberTrait) }}
					</div>
				</td>
				<td [ngStyle]="{ width: '120px' }">
					<select [(ngModel)]="numberTrait.priority"
							[disabled]="numberTrait.condition === TraitCondition.DROP_TRAIT" class="form-select">
						<ng-container>
							<option *ngFor="let opt of traitWeightOptions" [value]="opt.value">
								{{ opt.label | translate }}
							</option>
						</ng-container>
					</select>
				</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<tbody>
			<tr>
				<td class="no-records" colspan="10" jhiTranslate="no.data"></td>
			</tr>
			</tbody>
		</ng-template>
	</div>
</div>
